import React from 'react'

function Timer({ expiresAtTimestamp, data }) {
  return (
    <div className="d-flex justify-content-center align-items-center rounded bg-seafoam-l80 p-2 mb-4 mb-md-5">
      <span>Reserved for&nbsp;</span>
      <div
        className="timer-sm"
        data-controller="timer"
        data-timer-end-timestamp-seconds-value={expiresAtTimestamp}
        data-timer-data-value={JSON.stringify(data)}
      />
    </div>
  )
}

export default Timer
